module.exports = __webpack_public_path__ + "static/portfolio-financing-background-1e0dbbd8091745bfaf2a04209b2b0ecb.jpg";